const compatModules = {};import * as Mod1 from "./discourse/assigned-group-route-map";
compatModules["discourse/assigned-group-route-map"] = Mod1;

export * as discourse$assigned__group__route__map$$__module from "./discourse/assigned-group-route-map";
export {
default as discourse$assigned__group__route__map$$default
} from "./discourse/assigned-group-route-map";
import * as Mod2 from "./discourse/assigned-messages-route-map";
compatModules["discourse/assigned-messages-route-map"] = Mod2;

export * as discourse$assigned__messages__route__map$$__module from "./discourse/assigned-messages-route-map";
export {
default as discourse$assigned__messages__route__map$$default
} from "./discourse/assigned-messages-route-map";
import * as Mod3 from "./discourse/assigns-activity-route-map";
compatModules["discourse/assigns-activity-route-map"] = Mod3;

export * as discourse$assigns__activity__route__map$$__module from "./discourse/assigns-activity-route-map";
export {
default as discourse$assigns__activity__route__map$$default
} from "./discourse/assigns-activity-route-map";
import * as Mod4 from "./discourse/components/assign-actions-dropdown";
compatModules["discourse/components/assign-actions-dropdown"] = Mod4;

export * as discourse$components$assign__actions__dropdown$$__module from "./discourse/components/assign-actions-dropdown";
export {
default as discourse$components$assign__actions__dropdown$$default
} from "./discourse/components/assign-actions-dropdown";
import * as Mod5 from "./discourse/components/assign-button";
compatModules["discourse/components/assign-button"] = Mod5;

export * as discourse$components$assign__button$$__module from "./discourse/components/assign-button";
export {
default as discourse$components$assign__button$$default
} from "./discourse/components/assign-button";
import * as Mod6 from "./discourse/components/assign-user-form";
compatModules["discourse/components/assign-user-form"] = Mod6;

export * as discourse$components$assign__user__form$$__module from "./discourse/components/assign-user-form";
export {
default as discourse$components$assign__user__form$$default
} from "./discourse/components/assign-user-form";
import * as Mod7 from "./discourse/components/assigned-to-first-post";
compatModules["discourse/components/assigned-to-first-post"] = Mod7;

export * as discourse$components$assigned__to__first__post$$__module from "./discourse/components/assigned-to-first-post";
export {
default as discourse$components$assigned__to__first__post$$default
} from "./discourse/components/assigned-to-first-post";
import * as Mod8 from "./discourse/components/assigned-to-post";
compatModules["discourse/components/assigned-to-post"] = Mod8;

export * as discourse$components$assigned__to__post$$__module from "./discourse/components/assigned-to-post";
export {
default as discourse$components$assigned__to__post$$default
} from "./discourse/components/assigned-to-post";
import * as Mod9 from "./discourse/components/assigned-to";
compatModules["discourse/components/assigned-to"] = Mod9;

export * as discourse$components$assigned__to$$__module from "./discourse/components/assigned-to";
export {
default as discourse$components$assigned__to$$default
} from "./discourse/components/assigned-to";
import * as Mod10 from "./discourse/components/assigned-topic-list-column";
compatModules["discourse/components/assigned-topic-list-column"] = Mod10;

export * as discourse$components$assigned__topic__list__column$$__module from "./discourse/components/assigned-topic-list-column";
export {
default as discourse$components$assigned__topic__list__column$$default
} from "./discourse/components/assigned-topic-list-column";
import * as Mod11 from "./discourse/components/assignment";
compatModules["discourse/components/assignment"] = Mod11;

export * as discourse$components$assignment$$__module from "./discourse/components/assignment";
export {
default as discourse$components$assignment$$default
} from "./discourse/components/assignment";
import * as Mod12 from "./discourse/components/bulk-actions/assign-user";
compatModules["discourse/components/bulk-actions/assign-user"] = Mod12;

export * as discourse$components$bulk__actions$assign__user$$__module from "./discourse/components/bulk-actions/assign-user";
export {
default as discourse$components$bulk__actions$assign__user$$default
} from "./discourse/components/bulk-actions/assign-user";
import * as Mod13 from "./discourse/components/bulk-actions/bulk-assign-user";
compatModules["discourse/components/bulk-actions/bulk-assign-user"] = Mod13;

export * as discourse$components$bulk__actions$bulk__assign__user$$__module from "./discourse/components/bulk-actions/bulk-assign-user";
export {
default as discourse$components$bulk__actions$bulk__assign__user$$default
} from "./discourse/components/bulk-actions/bulk-assign-user";
import * as Mod14 from "./discourse/components/group-assigned-filter";
compatModules["discourse/components/group-assigned-filter"] = Mod14;

export * as discourse$components$group__assigned__filter$$__module from "./discourse/components/group-assigned-filter";
export {
default as discourse$components$group__assigned__filter$$default
} from "./discourse/components/group-assigned-filter";
import * as Mod15 from "./discourse/components/group-assigned-menu-item";
compatModules["discourse/components/group-assigned-menu-item"] = Mod15;

export * as discourse$components$group__assigned__menu__item$$__module from "./discourse/components/group-assigned-menu-item";
export {
default as discourse$components$group__assigned__menu__item$$default
} from "./discourse/components/group-assigned-menu-item";
import * as Mod16 from "./discourse/components/modal/assign-user";
compatModules["discourse/components/modal/assign-user"] = Mod16;

export * as discourse$components$modal$assign__user$$__module from "./discourse/components/modal/assign-user";
export {
default as discourse$components$modal$assign__user$$default
} from "./discourse/components/modal/assign-user";
import * as Mod17 from "./discourse/components/modal/edit-topic-assignments";
compatModules["discourse/components/modal/edit-topic-assignments"] = Mod17;

export * as discourse$components$modal$edit__topic__assignments$$__module from "./discourse/components/modal/edit-topic-assignments";
export {
default as discourse$components$modal$edit__topic__assignments$$default
} from "./discourse/components/modal/edit-topic-assignments";
import * as Mod18 from "./discourse/components/post-assignments-display";
compatModules["discourse/components/post-assignments-display"] = Mod18;

export * as discourse$components$post__assignments__display$$__module from "./discourse/components/post-assignments-display";
export {
default as discourse$components$post__assignments__display$$default
} from "./discourse/components/post-assignments-display";
import * as Mod19 from "./discourse/components/remind-assigns-frequency";
compatModules["discourse/components/remind-assigns-frequency"] = Mod19;

export * as discourse$components$remind__assigns__frequency$$__module from "./discourse/components/remind-assigns-frequency";
export {
default as discourse$components$remind__assigns__frequency$$default
} from "./discourse/components/remind-assigns-frequency";
import * as Mod20 from "./discourse/components/topic-assignments";
compatModules["discourse/components/topic-assignments"] = Mod20;

export * as discourse$components$topic__assignments$$__module from "./discourse/components/topic-assignments";
export {
default as discourse$components$topic__assignments$$default
} from "./discourse/components/topic-assignments";
import * as Mod21 from "./discourse/components/topic-level-assign-menu";
compatModules["discourse/components/topic-level-assign-menu"] = Mod21;

export * as discourse$components$topic__level__assign__menu$$__module from "./discourse/components/topic-level-assign-menu";
export {
default as discourse$components$topic__level__assign__menu$$default
} from "./discourse/components/topic-level-assign-menu";
import * as Mod22 from "./discourse/components/user-menu/assigns-list-empty-state";
compatModules["discourse/components/user-menu/assigns-list-empty-state"] = Mod22;

export * as discourse$components$user__menu$assigns__list__empty__state$$__module from "./discourse/components/user-menu/assigns-list-empty-state";
export {
default as discourse$components$user__menu$assigns__list__empty__state$$default
} from "./discourse/components/user-menu/assigns-list-empty-state";
import * as Mod23 from "./discourse/components/user-menu/assigns-list";
compatModules["discourse/components/user-menu/assigns-list"] = Mod23;

export * as discourse$components$user__menu$assigns__list$$__module from "./discourse/components/user-menu/assigns-list";
export {
default as discourse$components$user__menu$assigns__list$$default
} from "./discourse/components/user-menu/assigns-list";
import * as Mod24 from "./discourse/connectors/above-review-filters/assigned-to-filter.gjs";
compatModules["discourse/connectors/above-review-filters/assigned-to-filter"] = Mod24;

export * as discourse$connectors$above__review__filters$assigned__to__filter$$__module from "./discourse/connectors/above-review-filters/assigned-to-filter.gjs";
export {
default as discourse$connectors$above__review__filters$assigned__to__filter$$default
} from "./discourse/connectors/above-review-filters/assigned-to-filter.gjs";
import * as Mod25 from "./discourse/connectors/advanced-search-options-below/assigned-advanced-search.gjs";
compatModules["discourse/connectors/advanced-search-options-below/assigned-advanced-search"] = Mod25;

export * as discourse$connectors$advanced__search__options__below$assigned__advanced__search$$__module from "./discourse/connectors/advanced-search-options-below/assigned-advanced-search.gjs";
export {
default as discourse$connectors$advanced__search__options__below$assigned__advanced__search$$default
} from "./discourse/connectors/advanced-search-options-below/assigned-advanced-search.gjs";
import * as Mod26 from "./discourse/connectors/category-custom-settings/assign-settings-upsert.gjs";
compatModules["discourse/connectors/category-custom-settings/assign-settings-upsert"] = Mod26;

export * as discourse$connectors$category__custom__settings$assign__settings__upsert$$__module from "./discourse/connectors/category-custom-settings/assign-settings-upsert.gjs";
export {
default as discourse$connectors$category__custom__settings$assign__settings__upsert$$default
} from "./discourse/connectors/category-custom-settings/assign-settings-upsert.gjs";
import * as Mod27 from "./discourse/connectors/group-reports-nav-item/assigned-topic-list.gjs";
compatModules["discourse/connectors/group-reports-nav-item/assigned-topic-list"] = Mod27;

export * as discourse$connectors$group__reports__nav__item$assigned__topic__list$$__module from "./discourse/connectors/group-reports-nav-item/assigned-topic-list.gjs";
export {
default as discourse$connectors$group__reports__nav__item$assigned__topic__list$$default
} from "./discourse/connectors/group-reports-nav-item/assigned-topic-list.gjs";
import * as Mod28 from "./discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields.gjs";
compatModules["discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields"] = Mod28;

export * as discourse$connectors$groups__interaction__custom__options$assignable__interaction__fields$$__module from "./discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields.gjs";
export {
default as discourse$connectors$groups__interaction__custom__options$assignable__interaction__fields$$default
} from "./discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields.gjs";
import * as Mod29 from "./discourse/connectors/user-activity-bottom/assigned-list.gjs";
compatModules["discourse/connectors/user-activity-bottom/assigned-list"] = Mod29;

export * as discourse$connectors$user__activity__bottom$assigned__list$$__module from "./discourse/connectors/user-activity-bottom/assigned-list.gjs";
export {
default as discourse$connectors$user__activity__bottom$assigned__list$$default
} from "./discourse/connectors/user-activity-bottom/assigned-list.gjs";
import * as Mod30 from "./discourse/connectors/user-preferences-notifications/remind-assigns-frequency.gjs";
compatModules["discourse/connectors/user-preferences-notifications/remind-assigns-frequency"] = Mod30;

export * as discourse$connectors$user__preferences__notifications$remind__assigns__frequency$$__module from "./discourse/connectors/user-preferences-notifications/remind-assigns-frequency.gjs";
export {
default as discourse$connectors$user__preferences__notifications$remind__assigns__frequency$$default
} from "./discourse/connectors/user-preferences-notifications/remind-assigns-frequency.gjs";
import * as Mod31 from "./discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned.gjs";
compatModules["discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned"] = Mod31;

export * as discourse$connectors$user__preferences__tracking__topics$notification__level__when__assigned$$__module from "./discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned.gjs";
export {
default as discourse$connectors$user__preferences__tracking__topics$notification__level__when__assigned$$default
} from "./discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned.gjs";
import * as Mod32 from "./discourse/controllers/bulk-assign";
compatModules["discourse/controllers/bulk-assign"] = Mod32;

export * as discourse$controllers$bulk__assign$$__module from "./discourse/controllers/bulk-assign";
export {
default as discourse$controllers$bulk__assign$$default
} from "./discourse/controllers/bulk-assign";
import * as Mod33 from "./discourse/controllers/group/assigned";
compatModules["discourse/controllers/group/assigned"] = Mod33;

export * as discourse$controllers$group$assigned$$__module from "./discourse/controllers/group/assigned";
export {
default as discourse$controllers$group$assigned$$default
} from "./discourse/controllers/group/assigned";
import * as Mod34 from "./discourse/controllers/group/assigned/show";
compatModules["discourse/controllers/group/assigned/show"] = Mod34;

export * as discourse$controllers$group$assigned$show$$__module from "./discourse/controllers/group/assigned/show";
export {
default as discourse$controllers$group$assigned$show$$default
} from "./discourse/controllers/group/assigned/show";
import * as Mod35 from "./discourse/controllers/user-activity/assigned";
compatModules["discourse/controllers/user-activity/assigned"] = Mod35;

export * as discourse$controllers$user__activity$assigned$$__module from "./discourse/controllers/user-activity/assigned";
export {
default as discourse$controllers$user__activity$assigned$$default
} from "./discourse/controllers/user-activity/assigned";
import * as Mod36 from "./discourse/initializers/assign-admin-plugin-configuration-nav";
compatModules["discourse/initializers/assign-admin-plugin-configuration-nav"] = Mod36;

export * as discourse$initializers$assign__admin__plugin__configuration__nav$$__module from "./discourse/initializers/assign-admin-plugin-configuration-nav";
export {
default as discourse$initializers$assign__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/assign-admin-plugin-configuration-nav";
import * as Mod37 from "./discourse/initializers/assign-extend-user-messages";
compatModules["discourse/initializers/assign-extend-user-messages"] = Mod37;

export * as discourse$initializers$assign__extend__user__messages$$__module from "./discourse/initializers/assign-extend-user-messages";
export {
default as discourse$initializers$assign__extend__user__messages$$default
} from "./discourse/initializers/assign-extend-user-messages";
import * as Mod38 from "./discourse/initializers/assign-user-menu";
compatModules["discourse/initializers/assign-user-menu"] = Mod38;

export * as discourse$initializers$assign__user__menu$$__module from "./discourse/initializers/assign-user-menu";
export {
default as discourse$initializers$assign__user__menu$$default
} from "./discourse/initializers/assign-user-menu";
import * as Mod39 from "./discourse/initializers/assignment-list-actions";
compatModules["discourse/initializers/assignment-list-actions"] = Mod39;

export * as discourse$initializers$assignment__list__actions$$__module from "./discourse/initializers/assignment-list-actions";
export {
default as discourse$initializers$assignment__list__actions$$default
} from "./discourse/initializers/assignment-list-actions";
import * as Mod40 from "./discourse/initializers/extend-for-assigns";
compatModules["discourse/initializers/extend-for-assigns"] = Mod40;

export * as discourse$initializers$extend__for__assigns$$__module from "./discourse/initializers/extend-for-assigns";
export {
default as discourse$initializers$extend__for__assigns$$default
} from "./discourse/initializers/extend-for-assigns";
import * as Mod41 from "./discourse/lib/url";
compatModules["discourse/lib/url"] = Mod41;

export * as discourse$lib$url$$__module from "./discourse/lib/url";
export {
assignedToUserPath as discourse$lib$url$$assignedToUserPath,
assignedToGroupPath as discourse$lib$url$$assignedToGroupPath,
assignedToPostPath as discourse$lib$url$$assignedToPostPath
} from "./discourse/lib/url";
import * as Mod42 from "./discourse/models/assignment";
compatModules["discourse/models/assignment"] = Mod42;

export * as discourse$models$assignment$$__module from "./discourse/models/assignment";
export {
Assignment as discourse$models$assignment$$Assignment
} from "./discourse/models/assignment";
import * as Mod43 from "./discourse/models/topic";
compatModules["discourse/models/topic"] = Mod43;

export * as discourse$models$topic$$__module from "./discourse/models/topic";
export {
extendTopicModel as discourse$models$topic$$extendTopicModel
} from "./discourse/models/topic";
import * as Mod44 from "./discourse/pre-initializers/extend-category-for-assign";
compatModules["discourse/pre-initializers/extend-category-for-assign"] = Mod44;

export * as discourse$pre__initializers$extend__category__for__assign$$__module from "./discourse/pre-initializers/extend-category-for-assign";
export {
default as discourse$pre__initializers$extend__category__for__assign$$default
} from "./discourse/pre-initializers/extend-category-for-assign";
import * as Mod45 from "./discourse/routes/group/assigned";
compatModules["discourse/routes/group/assigned"] = Mod45;

export * as discourse$routes$group$assigned$$__module from "./discourse/routes/group/assigned";
export {
default as discourse$routes$group$assigned$$default
} from "./discourse/routes/group/assigned";
import * as Mod46 from "./discourse/routes/group/assigned/show";
compatModules["discourse/routes/group/assigned/show"] = Mod46;

export * as discourse$routes$group$assigned$show$$__module from "./discourse/routes/group/assigned/show";
export {
default as discourse$routes$group$assigned$show$$default
} from "./discourse/routes/group/assigned/show";
import * as Mod47 from "./discourse/routes/user-activity/assigned";
compatModules["discourse/routes/user-activity/assigned"] = Mod47;

export * as discourse$routes$user__activity$assigned$$__module from "./discourse/routes/user-activity/assigned";
export {
default as discourse$routes$user__activity$assigned$$default
} from "./discourse/routes/user-activity/assigned";
import * as Mod48 from "./discourse/routes/user-private-messages/assigned";
compatModules["discourse/routes/user-private-messages/assigned"] = Mod48;

export * as discourse$routes$user__private__messages$assigned$$__module from "./discourse/routes/user-private-messages/assigned";
export {
default as discourse$routes$user__private__messages$assigned$$default
} from "./discourse/routes/user-private-messages/assigned";
import * as Mod49 from "./discourse/routes/user-private-messages/assigned/index";
compatModules["discourse/routes/user-private-messages/assigned/index"] = Mod49;

export * as discourse$routes$user__private__messages$assigned$index$$__module from "./discourse/routes/user-private-messages/assigned/index";
export {
default as discourse$routes$user__private__messages$assigned$index$$default
} from "./discourse/routes/user-private-messages/assigned/index";
import * as Mod50 from "./discourse/services/task-actions";
compatModules["discourse/services/task-actions"] = Mod50;

export * as discourse$services$task__actions$$__module from "./discourse/services/task-actions";
export {
default as discourse$services$task__actions$$default
} from "./discourse/services/task-actions";
import * as Mod51 from "./discourse/templates/group/assigned";
compatModules["discourse/templates/group/assigned"] = Mod51;

export * as discourse$templates$group$assigned$$__module from "./discourse/templates/group/assigned";
export {
default as discourse$templates$group$assigned$$default
} from "./discourse/templates/group/assigned";
import * as Mod52 from "./discourse/templates/group/assigned/show";
compatModules["discourse/templates/group/assigned/show"] = Mod52;

export * as discourse$templates$group$assigned$show$$__module from "./discourse/templates/group/assigned/show";
export {
default as discourse$templates$group$assigned$show$$default
} from "./discourse/templates/group/assigned/show";
import * as Mod53 from "./discourse/templates/modal/bulk-assign";
compatModules["discourse/templates/modal/bulk-assign"] = Mod53;

export * as discourse$templates$modal$bulk__assign$$__module from "./discourse/templates/modal/bulk-assign";
export {
default as discourse$templates$modal$bulk__assign$$default
} from "./discourse/templates/modal/bulk-assign";
import * as Mod54 from "./discourse/templates/user-activity/assigned";
compatModules["discourse/templates/user-activity/assigned"] = Mod54;

export * as discourse$templates$user__activity$assigned$$__module from "./discourse/templates/user-activity/assigned";
export {
default as discourse$templates$user__activity$assigned$$default
} from "./discourse/templates/user-activity/assigned";
import * as Mod55 from "./discourse/templates/user-private-messages/assigned";
compatModules["discourse/templates/user-private-messages/assigned"] = Mod55;

export * as discourse$templates$user__private__messages$assigned$$__module from "./discourse/templates/user-private-messages/assigned";
export {
default as discourse$templates$user__private__messages$assigned$$default
} from "./discourse/templates/user-private-messages/assigned";
export default compatModules;
